import { useQuery } from 'react-query';
import { apiClient, endpoints } from '../api/client';

export interface DatabaseStatus {
  name: string;
  status: string;
  connections: number;
  size_mb: number;
  last_backup: string | null;
}

export const useDatabaseStatus = () => {
  return useQuery<DatabaseStatus[]>(
    'databaseStatus',
    async () => {
      const response = await apiClient.get(endpoints.systemStatus + '/database');
      return response.data;
    },
    {
      refetchInterval: 5000, // Refetch every 5 seconds
      staleTime: 0, // Always consider data stale
      cacheTime: 0, // Don't cache data
    }
  );
};
